module.exports = __webpack_public_path__ + "img/gys_26@2x.1df8050.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/gys_26@2x.png
// module id = JTCs
// module chunks = 0